import React, { useState } from 'react';
import { ChevronRightIcon, StarIcon, MapPinIcon, TruckIcon, HeartIcon, ShieldCheckIcon, InfoIcon, ChevronDownIcon, PawPrintIcon, RotateCcwIcon } from 'lucide-react';
import { ProductCard } from '../components/shared/ProductCard';
export function ProductDetailPage() {
  const [selectedSize, setSelectedSize] = useState('15kg');
  const [quantity, setQuantity] = useState(1);
  const sizes = [{
    size: '3kg',
    price: 32.99,
    memberPrice: 29.69,
    autoShipPrice: 28.04
  }, {
    size: '10kg',
    price: 89.99,
    memberPrice: 80.99,
    autoShipPrice: 76.49
  }, {
    size: '15kg',
    price: 109.99,
    memberPrice: 99.99,
    autoShipPrice: 93.49
  }, {
    size: '20kg',
    price: 139.99,
    memberPrice: 125.99,
    autoShipPrice: 118.99
  }];
  const currentSize = sizes.find(s => s.size === selectedSize) || sizes[2];
  const relatedProducts = [{
    name: 'Royal Canin Medium Puppy Dry Dog Food 15kg',
    price: 109.99,
    category: 'Dog Food',
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }, {
    name: 'Kong Classic Dog Toy Large',
    price: 29.99,
    category: 'Dog Toys',
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }, {
    name: 'Advocate Flea and Worming for Large Dogs 3 Pack',
    price: 65.99,
    category: 'Dog Health',
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }, {
    name: 'Greenies Dental Treats Regular 340g',
    price: 34.99,
    category: 'Dog Treats',
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }];
  return <main className="bg-white min-h-screen pb-20" data-id="element-652">
      {/* Breadcrumb */}
      <div className="border-b border-gray-100 py-4 bg-warm-50" data-id="element-653">
        <div className="container-wide flex items-center text-sm text-gray-500 overflow-x-auto whitespace-nowrap scrollbar-hide" data-id="element-654">
          <span className="hover:text-brand-blue cursor-pointer" data-id="element-655">Home</span>
          <ChevronRightIcon className="w-4 h-4 mx-2 flex-shrink-0" data-id="element-656" />
          <span className="hover:text-brand-blue cursor-pointer" data-id="element-657">
            Dogs and Puppies
          </span>
          <ChevronRightIcon className="w-4 h-4 mx-2 flex-shrink-0" data-id="element-658" />
          <span className="hover:text-brand-blue cursor-pointer" data-id="element-659">Dog Food</span>
          <ChevronRightIcon className="w-4 h-4 mx-2 flex-shrink-0" data-id="element-660" />
          <span className="font-medium text-gray-900 truncate" data-id="element-661">
            Royal Canin Medium Adult 15kg
          </span>
        </div>
      </div>

      <div className="container-wide pt-8 md:pt-12" data-id="element-662">
        <div className="grid grid-cols-1 lg:grid-cols-[220px_400px_1fr] gap-8 lg:gap-10 mb-16" data-id="element-663">
          {/* Left Sidebar — WooCommerce-style navigation */}
          <aside className="hidden lg:block" data-id="element-664">
            <div className="sticky top-28 space-y-4" data-id="element-665">
              {/* Search */}
              <div data-id="element-666">
                <div className="relative" data-id="element-667">
                  <input type="text" placeholder="Search products..." className="w-full bg-gray-50 border border-gray-200 rounded-lg py-2 pl-8 pr-3 text-xs text-gray-900 placeholder-gray-400 focus:outline-none focus:border-brand-blue focus:ring-1 focus:ring-brand-blue" data-id="element-668" />
                  <svg className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-669">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" data-id="element-670" />
                  </svg>
                </div>
              </div>

              {/* Categories */}
              <div data-id="element-671">
                <h4 className="text-[11px] font-bold text-gray-900 uppercase tracking-wider mb-3" data-id="element-672">
                  Categories
                </h4>
                <ul className="space-y-1.5" data-id="element-673">
                  {['Dog Food', 'Dog Treats', 'Dog Toys', 'Dog Health', 'Dog Accessories', 'Puppy', 'Dog Wash'].map(cat => <li key={cat} data-id="element-674">
                      <a href="#" className="text-xs text-gray-600 hover:text-brand-blue transition-colors flex items-center gap-1.5" data-id="element-675">
                        <span className="w-1 h-1 rounded-full bg-gray-300 flex-shrink-0" data-id="element-676"></span>
                        {cat}
                      </a>
                    </li>)}
                </ul>
              </div>

              {/* Brands */}
              <div data-id="element-677">
                <h4 className="text-[11px] font-bold text-gray-900 uppercase tracking-wider mb-3" data-id="element-678">
                  Brands
                </h4>
                <ul className="space-y-1.5" data-id="element-679">
                  {['Royal Canin', 'Black Hawk', 'Hills Science Diet', 'Pro Plan', 'Advance'].map(brand => <li key={brand} data-id="element-680">
                      <a href="#" className="text-xs text-gray-600 hover:text-brand-blue transition-colors flex items-center gap-1.5" data-id="element-681">
                        <span className="w-1 h-1 rounded-full bg-gray-300 flex-shrink-0" data-id="element-682"></span>
                        {brand}
                      </a>
                    </li>)}
                </ul>
              </div>

              {/* Price Range */}
              <div data-id="element-683">
                <h4 className="text-[11px] font-bold text-gray-900 uppercase tracking-wider mb-3" data-id="element-684">
                  Price
                </h4>
                <ul className="space-y-1.5" data-id="element-685">
                  {['Members Price', 'Auto Delivery Price', 'Price Per 100G'].map(range => <li key={range} data-id="element-686">
                      <a href="#" className="text-xs text-gray-600 hover:text-brand-blue transition-colors flex items-center gap-1.5" data-id="element-687">
                        <span className="w-1 h-1 rounded-full bg-gray-300 flex-shrink-0" data-id="element-688"></span>
                        {range}
                      </a>
                    </li>)}
                </ul>
              </div>

              {/* Size */}
              <div data-id="element-689">
                <h4 className="text-[11px] font-bold text-gray-900 uppercase tracking-wider mb-3" data-id="element-690">
                  Size
                </h4>
                <ul className="space-y-1.5" data-id="element-691">
                  {['3kg', '10kg', '15kg', '20kg'].map(size => <li key={size} data-id="element-692">
                      <a href="#" className="text-xs text-gray-600 hover:text-brand-blue transition-colors flex items-center gap-1.5" data-id="element-693">
                        <span className="w-1 h-1 rounded-full bg-gray-300 flex-shrink-0" data-id="element-694"></span>
                        {size}
                      </a>
                    </li>)}
                </ul>
              </div>

              {/* Tags */}
              <div data-id="element-695">
                <h4 className="text-[11px] font-bold text-gray-900 uppercase tracking-wider mb-3" data-id="element-696">
                  Tags
                </h4>
                <div className="flex flex-wrap gap-1.5" data-id="element-697">
                  {['Grain Free', 'Large Breed', 'Puppy', 'Senior', 'Weight Control', 'Sensitive', 'Pet Suitability', 'Life Stage'].map(tag => <a key={tag} href="#" className="text-[10px] px-2 py-1 bg-gray-100 text-gray-600 rounded-md hover:bg-brand-blue-50 hover:text-brand-blue transition-colors" data-id="element-698">
                      {tag}
                    </a>)}
                </div>
              </div>

              {/* Product Details */}
              <div data-id="element-699">
                <h4 className="text-[11px] font-bold text-gray-900 uppercase tracking-wider mb-3" data-id="element-700">
                  Product Details
                </h4>
                <ul className="space-y-1.5" data-id="element-701">
                  {['Ingredients', 'Feeding Guide', 'Features', 'Specifications', 'Reviews', 'Wish List'].map(item => <li key={item} data-id="element-702">
                      <a href="#" className="text-xs text-gray-600 hover:text-brand-blue transition-colors flex items-center gap-1.5" data-id="element-703">
                        <span className="w-1 h-1 rounded-full bg-gray-300 flex-shrink-0" data-id="element-704"></span>
                        {item}
                      </a>
                    </li>)}
                </ul>
              </div>
            </div>
          </aside>

          {/* Image Gallery */}
          <div className="space-y-4" data-id="element-705">
            <div className="aspect-square bg-brand-blue-50 rounded-2xl flex items-center justify-center relative border border-gray-100" data-id="element-706">
              <div className="absolute top-4 left-4" data-id="element-707">
                <span className="badge-blue text-sm px-3 py-1 shadow-sm" data-id="element-708">
                  Best Seller
                </span>
              </div>
              <PawPrintIcon className="w-32 h-32 text-brand-blue-300" data-id="element-709" />
            </div>
            <div className="grid grid-cols-4 gap-4" data-id="element-710">
              {[1, 2, 3, 4].map(i => <div key={i} className={`aspect-square rounded-xl flex items-center justify-center cursor-pointer border-2 ${i === 1 ? 'border-brand-blue bg-brand-blue-50' : 'border-transparent bg-warm-50 hover:bg-warm-100'}`} data-id="element-711">
                  <PawPrintIcon className={`w-8 h-8 ${i === 1 ? 'text-brand-blue-400' : 'text-gray-400'}`} data-id="element-712" />
                </div>)}
            </div>

            {/* Trust Badges — moved under photos */}
            <div className="grid grid-cols-2 gap-3 mt-2" data-id="element-713">
              <div className="flex flex-col items-center text-center p-3 bg-warm-50 rounded-xl" data-id="element-714">
                <ShieldCheckIcon className="w-6 h-6 text-brand-blue mb-1" data-id="element-715" />
                <span className="font-bold text-xs text-gray-900" data-id="element-716">
                  WA Owned
                </span>
              </div>
              <div className="flex flex-col items-center text-center p-3 bg-warm-50 rounded-xl" data-id="element-717">
                <InfoIcon className="w-6 h-6 text-brand-blue mb-1" data-id="element-718" />
                <span className="font-bold text-xs text-gray-900" data-id="element-719">
                  Expert Advice
                </span>
              </div>
              <div className="flex flex-col items-center text-center p-3 bg-warm-50 rounded-xl" data-id="element-720">
                <TruckIcon className="w-6 h-6 text-brand-blue mb-1" data-id="element-721" />
                <span className="font-bold text-xs text-gray-900" data-id="element-722">
                  Free Delivery
                </span>
              </div>
              <div className="flex flex-col items-center text-center p-3 bg-warm-50 rounded-xl" data-id="element-723">
                <HeartIcon className="w-6 h-6 text-brand-blue mb-1" data-id="element-724" />
                <span className="font-bold text-xs text-gray-900" data-id="element-725">
                  Care Club
                </span>
              </div>
            </div>
          </div>

          {/* Product Info */}
          <div className="flex flex-col" data-id="element-726">
            <div className="mb-2 text-sm font-bold text-gray-500 uppercase tracking-wider" data-id="element-727">
              Royal Canin
            </div>
            <h1 className="font-heading font-extrabold text-3xl md:text-4xl text-gray-900 mb-4 leading-tight" data-id="element-728">
              Royal Canin Medium Adult Dry Dog Food 15kg
            </h1>

            <div className="flex items-center gap-4 mb-6" data-id="element-729">
              <div className="flex items-center gap-1 text-yellow-500" data-id="element-730">
                <StarIcon className="w-5 h-5 fill-current" data-id="element-731" />
                <StarIcon className="w-5 h-5 fill-current" data-id="element-732" />
                <StarIcon className="w-5 h-5 fill-current" data-id="element-733" />
                <StarIcon className="w-5 h-5 fill-current" data-id="element-734" />
                <StarIcon className="w-5 h-5 fill-current opacity-50" data-id="element-735" />
              </div>
              <span className="text-sm font-medium text-brand-blue hover:underline cursor-pointer" data-id="element-736">
                4.7 (23 reviews)
              </span>
            </div>

            {/* Size and Action Area Row */}
            <div className="flex flex-col xl:flex-row gap-6 mb-8 items-end" data-id="element-737">
              {/* Left: Size Selector */}
              <div className="flex-1" data-id="element-738">
                <div className="text-sm font-bold text-gray-700 mb-3" data-id="element-739">
                  Select Size:
                </div>
                <div className="flex flex-wrap gap-2" data-id="element-740">
                  {sizes.map(size => <button key={size.size} onClick={() => setSelectedSize(size.size)} className={`px-5 py-2.5 rounded-xl font-heading font-bold text-sm transition-all active:scale-95 ${selectedSize === size.size ? 'bg-brand-blue text-white shadow-md' : 'bg-white text-gray-700 border-2 border-gray-200 hover:border-brand-blue'}`} data-id="element-741">
                      {size.size}
                    </button>)}
                </div>
              </div>

              {/* Right: Action Buttons */}
              <div className="flex-1 space-y-2 w-full xl:w-auto" data-id="element-742">
                <div className="flex items-center gap-2" data-id="element-743">
                  <div className="w-24 flex items-center border border-gray-300 rounded-lg h-10" data-id="element-744">
                    <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="flex-1 h-full flex items-center justify-center text-gray-500 hover:bg-gray-50 rounded-l-lg text-lg font-medium active:scale-95" data-id="element-745">
                      -
                    </button>
                    <span className="flex-1 text-center font-bold text-gray-900 text-sm" data-id="element-746">
                      {quantity}
                    </span>
                    <button onClick={() => setQuantity(quantity + 1)} className="flex-1 h-full flex items-center justify-center text-gray-500 hover:bg-gray-50 rounded-r-lg text-lg font-medium active:scale-95" data-id="element-747">
                      +
                    </button>
                  </div>
                  <button className="flex-1 bg-white text-brand-blue border border-brand-blue hover:bg-brand-blue-50 font-heading font-bold rounded-lg h-10 text-xs transition-colors active:scale-95" data-id="element-748">
                    Check Store Availability
                  </button>
                </div>
                <button className="w-full bg-brand-blue hover:bg-brand-blue-600 text-white font-heading font-bold rounded-lg h-10 text-xs shadow-blue-glow transition-colors active:scale-95" data-id="element-749">
                  Add To Cart
                </button>
              </div>
            </div>

            {/* Multi-Tier Pricing */}
            <div className="mb-6 p-6 bg-warm-50 rounded-2xl border border-warm-200" data-id="element-750">
              <div className="space-y-3" data-id="element-751">
                <div className="flex items-center justify-between" data-id="element-752">
                  <span className="text-sm text-gray-500 line-through" data-id="element-753">
                    RRP: $129.99
                  </span>
                </div>
                <div className="flex items-end gap-3" data-id="element-754">
                  <span className="text-4xl font-bold text-brand-blue" data-id="element-755">
                    ${currentSize.price.toFixed(2)}
                  </span>
                  <span className="text-sm text-gray-600 mb-1" data-id="element-756">Our Price</span>
                </div>

                <div className="flex items-center gap-2 p-3 bg-brand-green-50 rounded-xl border border-brand-green-100" data-id="element-757">
                  <HeartIcon className="w-5 h-5 text-brand-green fill-current" data-id="element-758" />
                  <div data-id="element-759">
                    <span className="font-bold text-gray-900" data-id="element-760">
                      ${currentSize.memberPrice.toFixed(2)} for members
                    </span>
                    <span className="text-xs text-gray-600 ml-2" data-id="element-761">
                      Save $
                      {(currentSize.price - currentSize.memberPrice).toFixed(2)}
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-2 p-3 bg-brand-blue-50 rounded-xl border border-brand-blue-100" data-id="element-762">
                  <RotateCcwIcon className="w-5 h-5 text-brand-blue" data-id="element-763" />
                  <div data-id="element-764">
                    <span className="font-bold text-brand-blue" data-id="element-765">
                      ${currentSize.autoShipPrice.toFixed(2)} on Auto Ship
                    </span>
                    <span className="text-xs text-brand-blue-700 ml-2" data-id="element-766">
                      Save{' '}
                      {Math.round((currentSize.price - currentSize.autoShipPrice) / currentSize.price * 100)}
                      %
                    </span>
                  </div>
                </div>

                <div className="text-sm text-gray-500 pt-2" data-id="element-767">
                  ${(currentSize.price / parseFloat(selectedSize)).toFixed(2)}
                  /kg
                </div>
              </div>
            </div>

            <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-768">
              Complete feed for adult medium breed dogs (from 11 to 25 kg) -
              Over 12 months old. Helps support optimal digestibility thanks to
              an exclusive formula including very high quality protein and a
              balanced supply of dietary fibre.
            </p>

            {/* Logistics Info */}
            <div className="space-y-4 bg-white border border-gray-200 rounded-2xl p-5" data-id="element-769">
              <div className="flex gap-3" data-id="element-770">
                <MapPinIcon className="w-6 h-6 text-brand-blue flex-shrink-0" data-id="element-771" />
                <div data-id="element-772">
                  <h4 className="font-bold text-gray-900" data-id="element-773">
                    Available in selected stores
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-774">
                    Contact your local store to confirm stock before visiting.
                  </p>
                </div>
              </div>
              <div className="w-full h-px bg-gray-100" data-id="element-775"></div>
              <div className="flex gap-3" data-id="element-776">
                <TruckIcon className="w-6 h-6 text-brand-green flex-shrink-0" data-id="element-777" />
                <div data-id="element-778">
                  <h4 className="font-bold text-gray-900" data-id="element-779">
                    Local Delivery Available
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-780">
                    Free local delivery on eligible orders over $100 within 5km.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Product Details Accordion */}
        <div className="max-w-3xl mx-auto mb-20" data-id="element-781">
          <h2 className="font-heading font-extrabold text-2xl text-gray-900 mb-6" data-id="element-782">
            Product Details
          </h2>
          <div className="space-y-4" data-id="element-783">
            <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-784">
              <button className="w-full px-6 py-4 flex items-center justify-between text-left bg-white font-bold text-gray-900 active:scale-[0.99]" data-id="element-785">
                Key Features
                <ChevronDownIcon className="w-5 h-5 text-brand-blue" data-id="element-786" />
              </button>
            </div>
            <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-787">
              <button className="w-full px-6 py-4 flex items-center justify-between text-left bg-white font-bold text-gray-900 active:scale-[0.99]" data-id="element-788">
                Ingredients and Nutrition
                <ChevronDownIcon className="w-5 h-5 text-brand-blue" data-id="element-789" />
              </button>
            </div>
            <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-790">
              <button className="w-full px-6 py-4 flex items-center justify-between text-left bg-white font-bold text-gray-900 active:scale-[0.99]" data-id="element-791">
                Feeding Guide
                <ChevronDownIcon className="w-5 h-5 text-brand-blue" data-id="element-792" />
              </button>
            </div>
          </div>
        </div>

        {/* Related Products */}
        <div className="mb-20" data-id="element-793">
          <h2 className="font-heading font-extrabold text-2xl md:text-3xl text-gray-900 mb-8" data-id="element-794">
            You Might Also Like
          </h2>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-795">
            {relatedProducts.map((product, index) => <ProductCard key={index} {...product} data-id="element-796" />)}
          </div>
        </div>

        {/* Advice CTA */}
        <div className="bg-gradient-to-r from-brand-blue-50 to-brand-green-50 rounded-2xl p-8 md:p-12 text-center border border-gray-100" data-id="element-797">
          <h3 className="font-heading font-extrabold text-2xl md:text-3xl text-gray-900 mb-4" data-id="element-798">
            Need advice on choosing the right food?
          </h3>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-799">
            Our team of local experts can help you find the perfect nutrition
            for your pet's specific needs, age, and breed.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-800">
            <button className="btn-primary active:scale-95" data-id="element-801">
              Find Your Local Store
            </button>
            <button className="btn-secondary bg-white active:scale-95" data-id="element-802">
              Read Our Feeding Guides
            </button>
          </div>
        </div>
      </div>
    </main>;
}